export enum ProductType {
  AutoRenewableSubscription = 'Auto‑Renewable Subscription',
  OneTimePurchase = 'One Time Purchase',
}
